import { render } from "./AutomaticStamps.vue?vue&type=template&id=c35ce68c"
import script from "./AutomaticStamps.vue?vue&type=script&lang=js"
export * from "./AutomaticStamps.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/halisclock/releases/44/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__